var FileExtensions;
(function (FileExtensions) {
    FileExtensions["BAT"] = "bat";
    FileExtensions["CMD"] = "cmd";
    FileExtensions["COM"] = "com";
    FileExtensions["EXE"] = "exe";
    FileExtensions["PIF"] = "pif";
    FileExtensions["SCR"] = "scr";
    FileExtensions["VBS"] = "vbs";
    FileExtensions["WS"] = "ws";
})(FileExtensions || (FileExtensions = {}));
export default FileExtensions;
//# sourceMappingURL=file-extensions.js.map